import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from 'src/utils/analytics';

const PageTracking = () => {
  const location = useLocation();
  const prevPathRef = useRef();
  
  useEffect(() => {
    // Evitar enviar el mismo pageview múltiples veces
    if (prevPathRef.current !== location.pathname) {
      // Capturar la ruta completa incluyendo parámetros de query
      const currentPath = location.pathname + location.search;
      trackPageView(currentPath);
      
      // Actualizar la referencia
      prevPathRef.current = location.pathname;
    }
  }, [location]);
  
  return null;
};

export default PageTracking;